import React, { Component } from 'react';
import { Glyphicon, Panel, Button, ButtonGroup, Tab, Nav, NavItem } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import EditableMarkdown from '../EditableMarkdown';
import ToggleSwitch from '../../ToggleSwitch';
import Checkbox from '../../Checkbox';
import RedflagComponent from '../Redflag/RedflagComponent';
import '../../../content/css/CategoryPanel.css';

export default class CategoryPanel extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            open: false,
            activeTab: null,
            categoryTheme: null
        };
    }

    componentDidMount() {
        this.setState({ categoryTheme: this.props.categoryTheme });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.categoryTheme !== this.props.categoryTheme) {
            this.setState({ categoryTheme: this.props.categoryTheme });
        }
    }

    getCurrentCategoryTheme() {
        if (this.state.categoryTheme) return this.state.categoryTheme;
        else return this.props.categoryTheme;
    }

    handleToggle = () => {
        this.setState({ open: !this.state.open });
    }

    handleIsActiveToggle = (isActive, oldIsActive) => {
        if (!this.props.isAllowedToEdit) return;
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.isActive = isActive;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleHighlightWhenFoundToggle = (highlightWhenFound, oldHighlightWhenFound) => {
        if (!this.props.isAllowedToEdit) return;
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.highlightWhenFound = highlightWhenFound;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleWarnWhenMissingToggle = (warnWhenMissing, oldWarnWhenMissing) => {
        if (!this.props.isAllowedToEdit) return;
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.warnWhenMissing = warnWhenMissing;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleTabSelect = (key) => {
        this.setState({ activeTab: key });
    }

    handleEditFeedbackGuidance = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackGuidance = text;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleEditFeedbackExamples = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackExamples = text;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleEditFeedbackExplanation = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackExplanation = text;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleEditFeedbackApproval = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackApproval = text;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleEditFeedbackMissingGuidance = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackMissingGuidance = text;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleEditFeedbackMissingExamples = (text, oldText) => {
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.feedbackMissingExamples = text;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleEditRisk = (riskType, oldRiskType) => {
        if (!this.props.isAllowedToEdit) return;
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.riskType = riskType;
        this.setState({ categoryTheme });
        this.props.onEdit(categoryTheme);
    }

    handleEditRedflag = (data, oldData) => {
        if (!this.props.isAllowedToEdit) return;
        let categoryTheme = Object.assign({}, this.state.categoryTheme);
        categoryTheme.customProperties = JSON.stringify(data);
        this.props.onEdit(categoryTheme);
    }

    renderEditableMarkdown = (markdown, onSave) => {
        if (this.props.isAllowedToEdit) {
            return (<EditableMarkdown
                markdown={markdown}
                onSave={onSave}
            />);
        }
        else {
            return (<div>
                <ReactMarkdown classname="box-content" source={markdown} escapeHtml={false} />
            </div>)
        };
    }

    render() {
        let theme = this.getCurrentCategoryTheme();
        let hasRedflag = theme.code == "G1" || theme.code == "I1";
        let isAllowedToEdit = this.props.isAllowedToEdit;

        return (
            <div className={`category-panel ${theme.isActive ? "" : "inactive"} `} key={theme.code}>
                <Panel eventKey="1" expanded={this.state.open}>
                    <Panel.Heading className={`risk-${theme.riskType} `} onClick={this.handleToggle}>
                        <div className="category-panel-heading">
                            <Panel.Title>{theme.name}</Panel.Title>
                            {this.state.open && <Glyphicon glyph="chevron-up" />}
                            {!this.state.open && <Glyphicon glyph="chevron-down" />}
                        </div>
                        <div className="ribbon" />
                    </Panel.Heading>
                    <Panel.Body collapsible>
                        <Tab.Container id="box-tabs" activeKey={this.state.activeTab ? this.state.activeTab : "guidance"} onSelect={this.handleTabSelect}>
                            <div>
                                <div className={`tabs risk-${theme.riskType} `}>
                                    <Nav bsStyle="pills" stacked>
                                        {theme.feedbackGuidance && <NavItem eventKey="guidance">What to do</NavItem>}
                                        {theme.feedbackExamples && <NavItem eventKey="examples">Example clause</NavItem>}
                                        {theme.feedbackExplanation && <NavItem eventKey="explanation">Background</NavItem>}
                                        {theme.feedbackApproval && <NavItem eventKey="approval">Get approval</NavItem>}
                                        {theme.warnWhenMissing && theme.feedbackMissingGuidance && <NavItem eventKey="missing_guidance">Guidance when Missing</NavItem>}
                                        {hasRedflag && <NavItem eventKey="redflag">Redflag</NavItem>}
                                        <NavItem eventKey="settings">Settings</NavItem>
                                    </Nav>
                                </div>
                                <Tab.Content animation>
                                    {theme.feedbackGuidance &&
                                        <Tab.Pane eventKey="guidance">
                                            {this.renderEditableMarkdown(theme.feedbackGuidance, this.handleEditFeedbackGuidance)}
                                        </Tab.Pane>
                                    }

                                    {theme.feedbackExamples &&
                                        <Tab.Pane eventKey="examples">
                                            {this.renderEditableMarkdown(theme.feedbackExamples, this.handleEditFeedbackExamples)}
                                        </Tab.Pane>
                                    }

                                    {theme.feedbackExplanation &&
                                        <Tab.Pane eventKey="explanation">
                                            {this.renderEditableMarkdown(theme.feedbackExplanation, this.handleEditFeedbackExplanation)}
                                        </Tab.Pane>
                                    }

                                    {theme.feedbackApproval &&
                                        <Tab.Pane eventKey="approval">
                                            {this.renderEditableMarkdown(theme.feedbackApproval, this.handleEditFeedbackApproval)}
                                        </Tab.Pane>
                                    }

                                    {theme.warnWhenMissing && theme.feedbackMissingGuidance &&
                                        <Tab.Pane eventKey="missing_guidance">
                                            {this.renderEditableMarkdown(theme.feedbackMissingGuidance, this.handleEditFeedbackMissingGuidance)}
                                        </Tab.Pane>
                                    }

                                    {hasRedflag &&
                                        <Tab.Pane eventKey="redflag">
                                            <RedflagComponent
                                                category={theme}
                                                getCategory={this.props.getCategoryTheme}
                                                addOrUpdateCategoryTheme={(categoryTheme) => this.props.onEdit(categoryTheme)}
                                                onSave={this.handleEditRedflag}
                                            />
                                        </Tab.Pane>
                                    }

                                    <Tab.Pane eventKey="settings">
                                        <div>
                                            <div className="panel-title-column">
                                                <span className="panel-title">Importance</span>
                                                <span>How important is this concept?</span>
                                            </div>
                                            <ButtonGroup bsClass={`btn-group risk-select ${isAllowedToEdit ? "" : "disabled"}`}>
                                                <Button bsClass={`risk-0 ${theme.riskType == 0 ? "selected" : ""} btn btn`} onClick={() => this.handleEditRisk(0)}>Low</Button>
                                                <Button bsClass={`risk-1 ${theme.riskType == 1 ? "selected" : ""} btn btn`} onClick={() => this.handleEditRisk(1)}>Medium</Button>
                                                <Button bsClass={`risk-2 ${theme.riskType == 2 ? "selected" : ""} btn btn`} onClick={() => this.handleEditRisk(2)}>High</Button>
                                            </ButtonGroup>
                                            <hr />
                                            <div className="panel-title-column">
                                                <span className="panel-title">Highlight</span>
                                                <span>Should this concept be highlighted in contracts?</span>
                                            </div>
                                            <ToggleSwitch initialValue={theme.highlightWhenFound} isDisabled={!isAllowedToEdit} onChange={this.handleHighlightWhenFoundToggle} />
                                            <hr />
                                            <div className="panel-title-column">
                                                <span className="panel-title">Warn when missing</span>
                                                <span>Should we warn when this concept is missing in a contract?</span>
                                            </div>
                                            <ToggleSwitch initialValue={theme.warnWhenMissing} isDisabled={!isAllowedToEdit} onChange={this.handleWarnWhenMissingToggle} />
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </Panel.Body>
                </Panel>
                <Checkbox value={theme.isActive} isDisabled={!isAllowedToEdit} onChange={this.handleIsActiveToggle} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/UserView/CategoryPanel.js